const ArrowSvg = ({ color }) => {
  const d1 =
    '10.2071 17.7071L15.207 12.7071C15.5975 12.3166 15.5975 11.6834 15.207 11.2929L10.2071 6.2929C9.81659 5.90237';
  const d2 =
    '9.18343 5.90237 8.7929 6.29289C8.40237 6.68341 8.40237 7.31657 8.79289 7.7071L13.0857 12Z';
  return (
    <svg className="arrow-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M13.0857 12L8.79289 16.2929C8.40237 16.6834 8.40237 17.3166 8.7929 17.7071C9.18343 18.0976 9.81659 18.0976 ${d1} ${d2}`}
        fill={color}
      ></path>
    </svg>
  );
};

export default ArrowSvg;
